function getCookie(name: string): string | null {
  const parts = document.cookie.split(/;\s*/)
  for (let i = 0; i < parts.length; i++) {
    const partMap = parts[i].split('=')
    if (partMap[0] === name) {
      return partMap[1]
    }
  }
  return null
}

function setCookie(name: string, value: string, Days: number): void {
  const OneDay = 24 * 60 * 60
  const maxAge = OneDay * Days
  document.cookie = `${name}=${value};max-age=${maxAge};expires=${new Date(
    Date.now() + maxAge * 1000,
  )};path=/;domain=.foxrenderfarm.com`
}

export function handleReferrerTracking(blockCookieName: string, targetCookieName: string): void {
  const blockValue = getCookie(blockCookieName)
  if (!blockValue || Date.now() > +blockValue) {
    let referrer: string = document.referrer || document.URL

    if (document.referrer && window.location.search.includes('source=')) {
      if (referrer.includes('&')) {
        referrer = `${referrer}&${window.location.search.slice(1)}`
      } else {
        referrer += window.location.search
      }
    }
    // 记录24小时内不可覆盖
    setCookie(blockCookieName, new Date().setDate(new Date().getDate() + 1).toString(), 1)
    // 记录保持7天
    setCookie(targetCookieName, referrer, 7)
  }
}
